
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import Code from 'components/Code'
import Table, { Row, Column } from 'components/Table'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h3><em parentName="h3">{`[Deprecated]`}</em>{` `}<inlineCode parentName="h3">{`.extend`}</inlineCode></h3>
    <blockquote>
      <p parentName="blockquote">{`The `}<inlineCode parentName="p">{`.extend`}</inlineCode>{` API was removed in styled-components v4. Use `}<inlineCode parentName="p">{`styled(StyledComponent)`}</inlineCode>{` instead. For more information, see: `}<a parentName="p" {...{
          "href": "https://github.com/styled-components/styled-components/issues/1546"
        }}>{`https://github.com/styled-components/styled-components/issues/1546`}</a></p>
    </blockquote>
    <p>{`This is a method that creates a new `}<inlineCode parentName="p">{`StyledComponent`}</inlineCode>{` and extends its rules.`}</p>
    <Table head={['Arguments', 'Description']} mdxType="Table">
  <Row mdxType="Row">
    <Column mdxType="Column">
      1. <Code mdxType="Code">TaggedTemplateLiteral</Code>
    </Column>
    <Column mdxType="Column">A tagged template literal with your CSS and interpolations.</Column>
  </Row>
    </Table>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import styled from 'styled-components'

const Component = styled.div\`
  color: red;
\`

const Component2 = Component.extend\`
  background: white;
  color: blue;
\`
`}</code></pre>
    <p>{`Returns a new `}<inlineCode parentName="p">{`StyledComponent`}</inlineCode>{` with the new rules merged into the ones of the component
this method was called on.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;